import { HttpClient } from '@angular/common/http';
import { ThisReceiver } from '@angular/compiler';
import { Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges  } from '@angular/core';
import { Observable } from 'rxjs';
import * as api from '../api/apihandler';

@Directive({
  selector: '[SingleFileDrop]'
})
export class SingleFileDropDirective implements OnChanges {
  @Input() ngModel;
  @Output() ngModelChange = new EventEmitter();
  @Output() imgDrop = new EventEmitter();
  @Output() imgHov = new EventEmitter();
  el:HTMLElement;

  constructor(private http: HttpClient,public element: ElementRef) {
    this.el = element.nativeElement as HTMLElement;
    this.applyStyle();
    
   }
   ngOnChanges(changes: SimpleChanges): void {
       if(!!changes.ngModel && changes.ngModel.currentValue != changes.ngModel.previousValue){
        this.applyStyle();
      }
   }
  @HostListener('drop', ['$event'])
  onDrop($event) {
    $event.preventDefault();
    let transfer = !!$event.dataTransfer ? $event.dataTransfer.files : $event.target.files;
    this.imageUploader(transfer[0]).subscribe(
      (data)=> {
        console.log('emitting image', data)
        this.ngModelChange.emit(data)
        let s = this.el.style;
        s.border = 'none';
        s.borderColor = '#7b7b7c';
        s.color = '#7b7b7c';
      }
    )
    this.imgHov.emit(false);
  }

  @HostListener('dragover', ['$event'])
  onDragOver($event) {
    let s = this.el.style;
    s.border = '3px dashed'
    s.borderColor = 'skyblue';
    s.color = 'skyblue';
    $event.preventDefault();
    this.imgHov.emit(true);
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave($event) {
    let s = this.el.style;
    s.borderColor = '#7b7b7c';
    s.color = '#7b7b7c';
    $event.preventDefault();
    this.imgHov.emit(false);
  }

  @HostListener('click',['$event'])
  onClick($event){
    this.createFileChild();
  }

  @HostListener('mouseenter',['$event'])
  onMouseOver($event){
    let s = this.el.style;
    if(!!this.ngModel) {
      s.border = '3px dashed'
      s.borderColor = 'skyblue';
      s.color = 'skyblue';
    }
    else {
      s.borderColor = 'skyblue';
      s.color = 'skyblue';
    }
  }

  @HostListener('mouseleave',['$event'])
  onMouseLeave($event){
    let s = this.el.style;
    if(!!this.ngModel) {
      s.border = 'none';
      s.borderColor = '#7b7b7c';
      s.color = '#7b7b7c';
    }
    else {
      s.borderColor = '#7b7b7c';
      s.color = '#7b7b7c';
    }
  }

  applyStyle(){
    let s = this.el.style;
    s.cursor = 'pointer';
    if(!this.ngModel){
      s.border = '3px dashed #7b7b7c';
      s.borderRadius = '0.25rem';
      s.color = '#7b7b7c';
      s.display = 'flex';
      s.justifyContent = 'center';
      s.alignItems = 'center';
      s.fontWeight = '600';
    }
    else {
      s.border = 'none';
      s.borderColor = '#7b7b7c';
      s.color = '#7b7b7c';
    }
  }

  imageUploader(fileToUpload){
    return new Observable((observer)=> {
      let input = new FormData();
      input.append("file", fileToUpload);
      this.http.post(api.jubloApi + 'api/shared/attachments/file', input).subscribe(
        (res:any)=> {console.log(res),observer.next(res.fileId)},
        () => observer.next(null),
        ()=> observer.complete()
      )
    })
  }

  createFileChild(){
    let c = document.createElement('input');
    c.type = 'file';
    c.hidden = true;
    c.id = 'SingleFileDropInput';
    c.onblur = () => this.removeChild();
    c.onchange = ($event)=> this.onDrop($event) 
    this.el.appendChild(c);
    document.getElementById('SingleFileDropInput').click();
  }

  removeChild(){
    let a = document.getElementById('SingleFileDropInput');
    a.parentNode.removeChild(a);
  }
}
